import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FrequenciesList } from '../interfaces/frecuencyCadenceResponses.interface';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class SearchInspectionScheduleService {


  frequencies: FrequenciesList[] = [];
  private dataSource = new BehaviorSubject(new MatTableDataSource<FrequenciesList[]>([]));
  currentDataSource = this.dataSource.asObservable();

  private frequenciesSubject = new BehaviorSubject<FrequenciesList[]>([]);
  frequencies$: Observable<FrequenciesList[]> = this.frequenciesSubject.asObservable();

  supplierSource: BehaviorSubject<string> = new BehaviorSubject('');
  supplier: string = '';

  partNumber: string = '';
  partNumberSource: BehaviorSubject<string> = new BehaviorSubject('');

  plant: string = '';
  plantSource: BehaviorSubject<string> = new BehaviorSubject('');

  newScheduleNoData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  schedulerUImode: BehaviorSubject<string> = new BehaviorSubject('');

  private event$: BehaviorSubject<string> = new BehaviorSubject('');

  constructor() { }

  setDataSourceInspectionPlans(inspectionPlans: any[]) {
    this.updateFrequencies(inspectionPlans);
    const dataSource = new MatTableDataSource(inspectionPlans);
    this.dataSource.next(dataSource);
  }

  updateFrequencies(data: FrequenciesList[]): void {
    this.frequenciesSubject.next(data);
  }

  searchSupplierInspection(supplier: string) {
    this.supplier = supplier;
    this.supplierSource.next(supplier);
  }

  setMode(mode: string) {
    this.schedulerUImode.next(mode);
  }

  setEvent(event: string) {
    this.event$.next(event);
  }

  getEvent() {
    return this.event$.asObservable();
  }

  createFrecuency() {
    this.newScheduleNoData.next(true);
  }

  getMode() {
    this.schedulerUImode.subscribe((message) => {
      console.log('Message: ', message);
    })
    return this.schedulerUImode;
  }

  getSupplierInspection() {
    this.supplierSource.subscribe((message) => {
      console.log('Message: ', message);
    })
    return this.supplier;
  }

  fillFrequeciesList(data: FrequenciesList[]) {
    this.frequencies = data;
  }
  activeFrequencies(data: FrequenciesList[]) {
    
    const actives: FrequenciesList[] = data.filter(oneFrequency => oneFrequency.active === true);
    
    return actives;
  }

  getFrequeciesList(): FrequenciesList[] {
    return this.frequencies;
  }

  pushFrequencyToList(oneFrequency: FrequenciesList) {
    this.frequencies.push(oneFrequency);
  }

  searchPartNumber(partNumber: string) {
    this.partNumber = partNumber;
    this.partNumberSource.next(partNumber);
  }

  getPartNumber() {
    this.partNumberSource.subscribe((message) => {
      console.log('Message: ', message);
    })
    return this.partNumber;
  }

  searchPlant(partNumber: string) {
    this.plant = partNumber;
    this.plantSource.next(partNumber);
  }

  getPlant() {
    this.plantSource.subscribe((message) => {
      console.log('Message: ', message);
    })
    return this.plant;
  }
}
